import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Download } from 'lucide-react';

const SurveysTab = ({ surveys, fetchSurveys, handleExportSurveys }) => {
  const [selectedType, setSelectedType] = useState(null);

  useEffect(() => {
    fetchSurveys(selectedType);
  }, [selectedType]);

  const surveyTypes = ['cancellation', 'non_upgrade', 'upgrade'];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center justify-between">
            <span>Survey Responses</span>
            <div className="flex gap-2">
              <Button
                onClick={() => handleExportSurveys(selectedType)}
                variant="outline"
                size="sm"
              >
                <Download className="w-4 h-4 mr-2" />
                Export CSV
              </Button>
            </div>
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-2 mb-6">
            <Button
              onClick={() => setSelectedType(null)}
              variant={selectedType === null ? "default" : "outline"}
              size="sm"
            >
              All Surveys
            </Button>
            {surveyTypes.map(type => (
              <Button
                key={type}
                onClick={() => setSelectedType(type)}
                variant={selectedType === type ? "default" : "outline"}
                size="sm"
              >
                {type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
              </Button>
            ))}
          </div>

          <div className="space-y-4">
            {surveys.length === 0 ? (
              <p className="text-center text-gray-500 py-8">No survey responses yet</p>
            ) : (
              surveys.map((survey, index) => (
                <Card key={index} className="border">
                  <CardHeader>
                    <div className="flex justify-between items-start">
                      <div>
                        <CardTitle className="text-lg">{survey.user_name}</CardTitle>
                        <CardDescription>
                          {survey.user_email} • {survey.survey_type.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                        </CardDescription>
                      </div>
                      <Badge>
                        {new Date(survey.submitted_at).toLocaleDateString()}
                      </Badge>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <div className="space-y-3">
                      {Object.entries(survey.responses).map(([key, value]) => (
                        <div key={key}>
                          <p className="font-medium text-sm text-gray-600 mb-1">
                            {key.replace('question_', 'Question ')}
                          </p>
                          <p className="text-gray-800">{value}</p>
                        </div>
                      ))}
                    </div>
                  </CardContent>
                </Card>
              ))
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export { SurveysTab };
